import { Card, CardBody, CardHeader } from '@components/card/card';
import { Form, Badge } from 'react-bootstrap';
import { Icon } from '@iconify/react';
import { useTranslation } from 'react-i18next';
import styles from './style.module.css';

// function ApplicationCard({ app }: { app: any }) {
//   const { i18n } = useTranslation();
//   return (
//     <>
//       {/* <Card className='h-100 shadow-sm bg-body application-card'> */}
//       <Card className={`h-100 shadow-sm bg-body ${styles.cardHoverEffect}`}>
//         <CardHeader className='bg-theme bg-opacity-10 shadow'>
//           <div className='d-flex justify-content-between align-items-center  '>
//             <Icon
//               className='iconify fs-30px'
//               icon={app.icon}
//               width='35'
//               height='35'
//               style={{ color: app.color }}
//               aria-label={app.name + ' icon'}
//             />
//             <Form.Check
//               className={styles.switchHidden}
//               type='switch'
//               id={`custom-switch-${app.id}`}
//               checked={app.status === 'Active'}
//               readOnly // For demonstration, in a real app this would trigger an update
//             />
//           </div>
//         </CardHeader>
//         <CardBody className='d-flex flex-column'>
//           <div className='h6 mb-2'>{app.name}</div>
//           <div className='text-muted flex-grow-1 fs-12px'>
//             {i18n.language === 'en' ? app.description : app.description2}
//           </div>
//           <div className='d-flex justify-content-between align-items-center mt-3'>
//             <Badge bg='success' className='text-dark'>
//               Active
//             </Badge>
//           </div>
//         </CardBody>
//       </Card>
//     </>
//   );
// }

// export default ApplicationCard;

function ApplicationCard({
  app,
  onStatusChange,
  isSubmitting
}: {
  app: any;
  onStatusChange: any;
  isSubmitting: boolean;
}) {
  const { i18n, t } = useTranslation();

  // console.log(app);

  // const handleToggle = async () => {
  //   setIsLoading(true);
  //   try {
  //     const newStatus = app.status === 'Active' ? 'Inactive' : 'Active';
  //     // await changeModuleStatus(app.id, newStatus);
  //     onStatusChange(app.id, newStatus); // Callback to update parent state
  //   } catch (error) {
  //     alert('Failed to update module status');
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  return (
    <Card className={`h-100 shadow-sm bg-body ${styles.cardHoverEffect}`}>
      <CardHeader className='bg-theme bg-opacity-10 shadow'>
        <div className='d-flex justify-content-between align-items-center'>
          <Icon
            className='iconify fs-30px'
            icon={app.icon}
            width='35'
            height='35'
            style={{ color: app.color }}
            aria-label={`${app.name} icon`}
          />

          {isSubmitting ? (
            <div className='spinner-grow spinner-grow-sm text-theme'></div>
          ) : (
            <Form.Check
              className={styles.switchHidden}
              type='switch'
              id={`custom-switch-${app.id}`}
              checked={app.isActive}
              onChange={() => onStatusChange(app.id, !app.isActive)}
            />
          )}
        </div>
      </CardHeader>
      <CardBody className='d-flex flex-column'>
        <div className='h6 mb-2'>{app.name}</div>
        <div className='text-muted flex-grow-1 fs-12px'>
          {i18n.language === 'en' ? app.description : app.description2}
        </div>
        <div className='d-flex justify-content-between align-items-center mt-3'>
          <Badge bg={app.isActive ? 'success' : 'secondary'} className='text-dark'>
            {app.isActive === true ? t('IsActive') : t('InActive')}
          </Badge>
        </div>
      </CardBody>
    </Card>
  );
}

export default ApplicationCard;
